import CustomButton from '../../../common/components/CustomButton';
import CustomUpload from '../../../common/components/CustomUpload';
import PopupContainer from '../../../common/components/PopupContainer';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type KaraokeUploadForm2VideoPopupFileName = 'movie';

// 動画のアップロード（ポップアップ）
export default function KaraokeUploadForm2VideoPopup({
  getFiles,
  setFiles,
  getErrors,
  onClose,
} : {
  getFiles: (name: KaraokeUploadForm2VideoPopupFileName) => FileList|null,
  setFiles: (name: KaraokeUploadForm2VideoPopupFileName, value: FileList|null) => void,
  getErrors: (name: KaraokeUploadForm2VideoPopupFileName) => FieldValidationErrorsType,
  onClose: () => void,
}) {
  return (
    <PopupContainer title="ミュージックビデオ" onClose={() => onClose()}>
      <div className="list__body">
        <p className="list__addtext">
          ミュージックビデオをアップロードしてください。
          <br />
          これに歌詞テロップが追加された映像がカラオケ店で流れます。
          <br />
          <br />
          <p className="list__addtext_item">・「歌が入っているミュージックビデオ」をアップロードしてください。</p>
          <br />
          <p className="list__addtext_item">・映像に歌詞が含まれていると、その上に歌詞テロップが重なるため読みづらくなります。歌詞が含まれていない映像を推奨します。</p>
          <br />
          <p className="list__addtext_item">
            ・他者の権利を侵害するものが映っていると、修正（有償）や配信停止（返金不可）となる可能性があります。
            <br />
            <div className="list__bg">
              <b>よくあるNG例：</b>
              <br />
              許諾を得ていない人物の顔、キャラクター、企業や商品のロゴ、映像作品やゲームのワンシーン、商用利用不可の映像素材、編集ソフトのウォーターマークなど
            </div>
          </p>
          <p className="list__addtext_item">
            ・
            <b>推奨する動画仕様：</b>
            <br />
            サイズ：960×540px以上、2560×1440px以下
            <br />
            アスペクト比：16:9
            <br />
            フレームレート：29.97fps
            <br />
            上記に該当しない動画でも配信可能ですが、映像の品質が落ちる場合があります。その場合も返金はできませんのでご注意ください。
            <br />
          </p>
          <p className="list__addtext_item">・ミュージックビデオよりも「歌なし音源」の方が歌い出しが遅い（音源の冒頭にカウントを追加しているなど）と配信できません。その場合はミュージックビデオ冒頭に無音時間を追加して提出してください。
          </p>
        </p>
        <div className="form__body">
          <dl>
            <dd>
              <CustomUpload
                type="video"
                description="mp4、mov、wmv(1.3GB以内)"
                files={getFiles('movie')}
                onSelectFiles={(value) => setFiles('movie', value)}
                onDeleteFiles={() => setFiles('movie', null)}
                validationErrors={getErrors('movie')}
              />
              <p className="text_info_on" />
            </dd>
          </dl>
        </div>
        <ul>
          <li className="bt w100">
            <CustomButton type="default" disabled={Object.keys(getErrors('movie')).length > 0} onClick={() => onClose()}>設定する</CustomButton>
          </li>
        </ul>
      </div>
    </PopupContainer>
  );
}
